exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".footer {\n  bottom: 0;\n  border-width: 0 0 1px;\n  position: absolute;\n  right: 0;\n  left: 0;\n  min-height: 50px;\n  margin-top: 20px;\n  border: 1px solid transparent;\n  background-color: #052453;\n  color: #fffbfb;\n  text-align: left; }\n  .footer-copyright {\n    padding: 1em 2em; }\n    @media (max-width: 370px) {\n      .footer-copyright {\n        font-size: 70%; } }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/jonshilton/Projects/nick-smith-app/src/app/components/footer/footer.component.scss
// module id = ../../../../../src/app/components/footer/footer.component.scss
// module chunks = 0